
import { EventLogDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import {  eventLogService, EventLogsFilters } from '@services/eventLogService'

const { reducer, actions, thunks } = baseCrudReducer<
  EventLogDto,
  {},
  {},
  EventLogsFilters
>('eventLog', eventLogService)

export default reducer

export const { setFilters: setEventLogFilters } = actions

export const {
  getAll: getEventLogs,
} = thunks
